export default __webpack_public_path__ + "adf0bcfcd257dcf3ab9678171940f6f5.png";